import { Filter } from './badwords'

const filter = new Filter({ splitRegex: /\b/ })

export function maskProfanity(text: string): string {
  if (!text || !filter.isProfane(text)) {
    return text
  }
  return filter.clean(text)
}
